// src/pages/Users.js
import React, { useState, useEffect } from 'react';
import { listenToUsers, updateUser, deleteUser } from '../services/firebase';
import toast from 'react-hot-toast';

export default function Users() {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [filter, setFilter] = useState('all');
  const [selected, setSelected] = useState(null);

  useEffect(() => { return listenToUsers(setUsers); }, []);

  const filtered = users.filter((u) => {
    const matchSearch = !search
      || u.name?.toLowerCase().includes(search.toLowerCase())
      || u.phone?.includes(search);
    const matchFilter = filter === 'all'
      || (filter === 'active' && !u.isBlocked)
      || (filter === 'blocked' && u.isBlocked);
    return matchSearch && matchFilter;
  });

  const handleBlock = async (user) => {
    await updateUser(user.id, { isBlocked: true });
    toast(`${user.name || 'Customer'} blocked`);
  };

  const handleUnblock = async (user) => {
    await updateUser(user.id, { isBlocked: false });
    toast.success(`${user.name || 'Customer'} unblocked`);
  };

  const handleDelete = async (user) => {
    if (!window.confirm(`Delete ${user.name || 'this customer'}? Their login will remain but profile data is removed.`)) return;
    await deleteUser(user.id);
    toast.success('Customer deleted');
    setSelected(null);
  };

  return (
    <div className="page-body">
      <div style={{ marginBottom: 24 }}>
        <div style={{ fontFamily: 'Clash Display, sans-serif', fontSize: 24, fontWeight: 700, marginBottom: 4 }}>Customers</div>
        <div style={{ fontSize: 13, color: 'var(--text2)' }}>{users.length} registered customers</div>
      </div>

      <div style={{ display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap' }}>
        <div style={{ position: 'relative', flex: 1, maxWidth: 300 }}>
          <span style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)' }}>🔍</span>
          <input placeholder="Search by name or phone..." value={search} onChange={(e) => setSearch(e.target.value)} style={{ paddingLeft: 32 }} />
        </div>
        {['all', 'active', 'blocked'].map((f) => (
          <button key={f} type="button" className={`btn ${filter === f ? 'btn-green' : 'btn-ghost'} btn-sm`} onClick={() => setFilter(f)} style={{ textTransform: 'capitalize', padding: '8px 14px' }}>
            {f}
          </button>
        ))}
      </div>

      <div className="table-card">
        <table>
          <thead>
            <tr>
              <th>CUSTOMER</th>
              <th>PHONE</th>
              <th>STATUS</th>
              <th>JOINED</th>
              <th>ACTIONS</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan={5} style={{ textAlign: 'center', color: 'var(--text2)', padding: 32 }}>No customers found</td></tr>
            ) : filtered.map((u) => (
              <tr key={u.id} onClick={() => setSelected(u)} style={{ cursor: 'pointer' }}>
                <td>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 32, height: 32, borderRadius: '50%', background: 'var(--blue-dim)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 16 }}>👤</div>
                    <span style={{ fontWeight: 600 }}>{u.name || 'Unknown'}</span>
                  </div>
                </td>
                <td style={{ fontFamily: 'JetBrains Mono', fontSize: 12 }}>{u.phone || '—'}</td>
                <td>
                  <span className={`badge ${u.isBlocked ? 'badge-red' : 'badge-green'}`}>
                    {u.isBlocked ? 'Blocked' : 'Active'}
                  </span>
                </td>
                <td style={{ fontSize: 12, color: 'var(--text2)' }}>{u.updatedAt?.toDate ? u.updatedAt.toDate().toLocaleDateString('en-IN') : '—'}</td>
                <td onClick={(e) => e.stopPropagation()}>
                  {!u.isBlocked ? (
                    <button type="button" className="btn btn-ghost btn-sm" onClick={() => handleBlock(u)}>Block</button>
                  ) : (
                    <button type="button" className="btn btn-ghost btn-sm" onClick={() => handleUnblock(u)}>Unblock</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selected && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }} onClick={() => setSelected(null)}>
          <div className="card" style={{ maxWidth: 400, width: '100%', padding: 24 }} onClick={(e) => e.stopPropagation()}>
            <div style={{ fontSize: 20, fontWeight: 800, marginBottom: 4 }}>{selected.name || 'Unknown'}</div>
            <div style={{ fontSize: 13, color: 'var(--text2)', marginBottom: 8 }}>{selected.phone || '—'}</div>
            <span className={`badge ${selected.isBlocked ? 'badge-red' : 'badge-green'}`} style={{ marginBottom: 16, display: 'inline-flex' }}>
              {selected.isBlocked ? 'Blocked' : 'Active'}
            </span>
            <div style={{ fontSize: 11, color: 'var(--text2)', fontFamily: 'JetBrains Mono', marginBottom: 20, wordBreak: 'break-all' }}>{selected.id}</div>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {!selected.isBlocked ? (
                <button type="button" className="btn btn-red" onClick={() => { handleBlock(selected); setSelected({ ...selected, isBlocked: true }); }}>Block customer</button>
              ) : (
                <button type="button" className="btn btn-green" onClick={() => { handleUnblock(selected); setSelected({ ...selected, isBlocked: false }); }}>Unblock customer</button>
              )}
              <button type="button" className="btn btn-ghost" style={{ color: 'var(--red)' }} onClick={() => handleDelete(selected)}>Delete profile</button>
              <button type="button" className="btn btn-ghost" onClick={() => setSelected(null)}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
